import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from "@angular/common/http";
import { Observable } from "rxjs";
import { PsiData } from '../_models/psi-data';
import { API_URL } from "../_common/constants";
import { AuthenticationService } from "../user/_services/authentication.service";
import { Modules } from "../_common/_enum/module.enum";

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  getBusinessLookupToken(){
    return this.authenticationService.getModule(Modules.NBDNBLookup).token.token;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    /* req = req.clone({
      withCredentials: true
    }); */
    let psiData: PsiData = JSON.parse(sessionStorage.getItem('psiData'));
    if(psiData && psiData.currentUser && psiData.currentUser.SID){
      if (req.url.includes(API_URL.BusinessLookup)) {
        const businessLookupReq = req.clone({ setHeaders: { 'Authorization':'Bearer ' + this.getBusinessLookupToken() } });
        return next.handle(businessLookupReq);
      }
      else{
        if (psiData.currentUser.antiForgeryToken) {
          const modified = req.clone({ setHeaders: { "SID": psiData.currentUser.SID, "UID": psiData.currentUser.UID, "X-XSRF-TOKEN": psiData.currentUser.antiForgeryToken }, withCredentials: true });
          return next.handle(modified);
        } else {
          const modified = req.clone({ setHeaders: { "SID": psiData.currentUser.SID, "UID": psiData.currentUser.UID }, withCredentials: true });
          return next.handle(modified);
        }
      }
    } else if(psiData && psiData.currentUser && psiData.currentUser.antiForgeryToken) {
      const xsrfReq = req.clone({ setHeaders: { "X-XSRF-TOKEN": psiData.currentUser.antiForgeryToken }, withCredentials: true });
      return next.handle(xsrfReq);
    }else{
        return next.handle(req);
    }

  }
}
